import { Signal, signal } from '@preact/signals-react'
import { useEffect, useState } from 'react'

function isSignal<T>(val: any): val is Signal<T> {
    return val && typeof val === 'object' && 'value' in val
}

export function useSyncedState<T>(
    tab: { store: Record<string, any> },
    key: string,
    fallback: T
): [T, (val: T) => void] {
    if (!isSignal<T>(tab.store[key])) {
        tab.store[key] = signal(fallback)
    }

    const storeSignal = tab.store[key] as Signal<T>
    const [state, setState] = useState<T>(storeSignal.value)

    // Prevent overwriting local state if user is actively typing
    useEffect(() => {
        const unsubscribe = storeSignal.subscribe((newVal) => {
            setState((prev) => {
                return Object.is(prev, newVal) ? prev : newVal
            })
        })
        return () => unsubscribe()
    }, [storeSignal])

    const setSynced = (val: T) => {
        setState(val)
        storeSignal.value = val
    }

    return [state, setSynced]
}
